import React from 'react';
import PropTypes from 'prop-types';
import { PaperPanelContainer } from './styled';

export const PaperPanel = ({ header, children, ...rest }) => (
  <PaperPanelContainer {...rest}>
    {header}
    {children}
  </PaperPanelContainer>
);

PaperPanel.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
};

PaperPanel.defaultProps = {
  header: null,
  children: null,
};

export default PaperPanel;
